function discountSavingPrice(){
    let originalPrice = parseFloat($('.js_product_var_change option:selected').attr('data-money_without-currency-price') * $('[name="product-count"]:checked').val()); // Get original price
    let discountPercentage = $('[name="product-count"]:checked').attr('data-dis-per'); // Set discount percentage
    let discountAmount = (originalPrice * discountPercentage) / 100; // Calculate discount
    let finalPrice = originalPrice - discountAmount; // Subtract discount from original price
    let formattedDiscount = Shopify.formatMoney(discountAmount, $('body').data('money-format'));
    if(discountAmount != 0){
       $('.save--price').show();
       $('.save--price').html(`(${formattedDiscount} savings)`);
       }else{
          $('.save--price').hide();
       }
    $('.product--price').text(Shopify.formatMoney(finalPrice, $('body').data('money-format')));
 }
 $(document).ready(function () {
    
    $(document).on('click', '.eq-pdp-choice--atc', function (e) {
       e.preventDefault();
       let parent = $(this).closest('.eq-box');
       let variantId = parent.find('.eq-pdp-choice--atc').attr('data-variant-id');
       let qty = 1;
       let data = {};
       let subscriptionRadioLength = parent.find('.eq-subscripiton-widget:checked').length;
       if (subscriptionRadioLength > 0) {
          let sellingPlanId = parent.find('.selling-plan--selector option:selected').val();
          data = {
             id: variantId,
             quantity: qty,
             selling_plan: sellingPlanId
          };
       } else {
          data = {
             id: variantId,
             quantity: qty
          };
       }
       $.ajax({
          url: "/cart/add.js",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
             window.location = "/cart";
          },
          error: function (xhr, status, error) {
             console.error("Error adding to cart:", error);
             console.error("Response Text:", xhr.responseText);
             window.alert(xhr.responseJSON.description);
          }
       });
    });
 
    $(document).on('change', '.eq-choice--radio', function (e) {
       let parent = $(this).closest('.eq-box');
       let widgetType = parent.find('.eq-choice--radio:checked').attr('data-widget-type');
       let subPrice = parent.find('.eq-choice--radio:checked').attr('data-price');
       if (widgetType == 'subscribe-save') {
          parent.find('.eq-pdp-choice--atc .price').html(subPrice);
       } else {
          parent.find('.eq-pdp-choice--atc .price').html(subPrice);
       }
    });
 
    $(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2],.js-cw-product-page-form [data-option-3]`, function (e) {
       let option1 = option2 = option3 = null;
       let inputType = $(this).attr('data-input-type');
       if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
          if (inputType == 'radio') {
             option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
          } else {
             option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
          }
       }
       if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
          if (inputType == 'radio') {
             option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
          } else {
             option2 = $(`.js-cw-product-page-form [data-option-2] option:selected`).val();
          }
       }
       if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
          if (inputType == 'radio') {
             option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
          } else {
             option3 = $(`.js-cw-product-page-form [data-option-3] option:selected`).val();
          }
       }
       let variant_id = null;
       let current_selected_option = null;
       if (option2 == null & option3 == null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
       }
       if (option2 != null & option3 == null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
       }
       if (option2 != null & option3 != null) {
 
          current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
          variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
       }
       if (variant_id == null) {
          $(`.pdp-atc-v2`).text("Unavailable");
          $(`.pdp-atc-v2`).css("pointer-events", "none");
          $(`.pdp-atc-v2`).css("opacity", "0.5");
          
          return true;
       }
       let price = $(current_selected_option).attr('data-price');
       let compare_at_price = $(current_selected_option).attr('data-compareat-price');
       let discount = $(current_selected_option).attr('data-discount');
       let itemQty = $(current_selected_option).attr('data-qty');
       let afterPayPrice = $(current_selected_option).attr('data-afterpayprice')
       let save = $(current_selected_option).attr('data-save');
       let is_available = $(current_selected_option).attr('data-available');
       let subscriptionPercentage = $(current_selected_option).attr('data-sub-per');
       var variantPrice = $(current_selected_option).attr('data-money_without-currency-price');
       let discountPrice = parseFloat((variantPrice * subscriptionPercentage) / 100);
       let subscriptionPrice = variantPrice - discountPrice;
       let savPercentage = $(current_selected_option).attr('data-save-per');
       let savePrice = $(current_selected_option).attr('data-save-price')
       var productSelctQty = $('.quantity-element.input').val();
       var productPrice = variantPrice * productSelctQty;
       var productQty = $('.quantity-element').val();
       var ProsavingPrice = parseFloat($(current_selected_option).attr('data-save-without-money')) || 0;
       let finalSaving = productQty * ProsavingPrice;
      
       $('.product--price').text(Shopify.formatMoney(productPrice, $('body').data('money-format')));
      //  $('.save--price').html(`(${savePrice} Saving)`);     
       let productSavePrice = Shopify.formatMoney(finalSaving, $('body').data('money-format'));  
       $('.save--price').html(`(${productSavePrice} Savings)`);
       // $('.js_save_price').text(savePrice);
       $('.subscription-price').html(Shopify.formatMoney(subscriptionPrice, $('body').data('money-format')));
       $('.js_afterpay').attr('data-amount', price);
       $(`.js_after_pay`).attr('data-price', afterPayPrice);
       let setAfterPayPrice = $('.js_after_pay').attr('data-price');
       let dividaedPrice = (setAfterPayPrice / 4).toFixed(2);
       
       if (save != '') {
          $(`.js_save_price`).html('save ' + save);
          $(`.js_save_price_wrap`).show();
          $('.js_save_percentage').text(savPercentage);
          $('.eq-discount-offer--wrapper').show();
       } else {
          $(`.js_save_price_wrap`).hide();
          $('.eq-discount-offer--wrapper').hide();
       }
 
       $(`.js_after_pay`).html('$' + dividaedPrice);
       $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
       // $(`.js-cw-product-page-form .js-compare-price`).text(compare_at_price);
       $(`.product__info-container s`).text(compare_at_price);
       $(`.js-price`).text(price);
       $(`.js-compare-price`).text(price);
       $(`.js-otp--price`).text(price);
       $(`.js_sticky_price`).html(price);
       $(`.js_sticky_price`).html(price);
       if (compare_at_price) {
          $(`.js-compare-price`).html(compare_at_price);
          $(`.js_sticky_comprice`).html(compare_at_price);
          $(`.js-compare-price`).show();
          $(`.js_sticky_comprice`).show();
       } else {
          $(`.js-compare-price`).hide();
          $(`.js_sticky_comprice`).hide();
       }
       $(`.js-cw-product-page-form .js_discount`).text('Save ' + discount + '%');
       $(`.jsproqty`).text(itemQty);
       if (is_available == 'true') {
          $(`.pdp-atc-v2 .atc--text`).html(`<img src="//joyorganics.com/cdn/shop/files/eq-product-btn-cart-icon_30x.png?v=9807713154866607732" alt="cart icon" data-uw-rm-alt-original="cart icon" data-uw-rm-alt="ALT"> Add to Cart`);
          $(`.pdp-atc-v2`).css("pointer-events", "all");
          $(`.pdp-atc-v2`).css("opacity", "1");
       } else {
          $(`.pdp-atc-v2`).css("pointer-events", "none");
          $(`.pdp-atc-v2`).css("opacity", "0.5");
          $(`.pdp-atc-v2 .atc--text`).text("Soldout");
       }
});
 
 
 
 
 });
 

 
 
 
 $(document).on('click', '.pdp-atc-v2', function (e) {
    e.preventDefault();
 
    let varId = $('.js_product_var_change option:selected').val();
    let oneTimeqty = $('.quantity-element.input').val();
    let data = {}; // Declare the data object outside the conditional block
    
    
    let discountCode = $('input[name="product-count"]:checked').attr('data-discount-code');
    let customFlavor = $('select[name="custom-flavor"]').val();
    let customStrength = $('.custom-meta-strength:checked').val();
   
    data = {
      id: varId,
      quantity: oneTimeqty,
      properties: {
         'Strength': customStrength,
         'Flavor': customFlavor
     }
   };
    
    $.ajax({
       url: "/cart/add.js",
       method: "POST",
       data: data,
       dataType: "json",
       success: function (data) {
          
          if(discountCode != ''){ 
          $.ajax({
             type: 'GET',
             url: '/discount/' + discountCode,
             success: function(discountResponse) {
                window.upcartRefreshCart();
             },
             error: function(xhr, status, error) {
                 console.error('Error applying discount:', error);
             }
         });
       }
       
        window.location = "/cart";
       },
       error: function (xhr, status, error) {
          console.error("Error adding to cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert(xhr.responseJSON.description);
       }
    });
 
 });
 
 $(document).on("change", '[name="product-count"]', function () {
    let newValue = $(this).val();
    if (newValue == 1) {
       $('.save--price').hide();
    } else {
       $('.save--price').show();
    }
    // discountSavingPrice();
   
    let originalPrice = parseFloat($('.js_product_var_change option:selected').attr('data-money_without-currency-price') * $(this).val()); // Get original price
    let discountPercentage = $(this).attr('data-dis-per');
    let discountAmount = (originalPrice * discountPercentage) / 100;
    let finalPrice = originalPrice - discountAmount;
    let formattedDiscount = Shopify.formatMoney(discountAmount, $('body').data('money-format'));
    if(discountAmount != 0){
    $('.save--price').show();
    $('.save--price').html(`(${formattedDiscount} savings)`);
    }else{
       $('.save--price').hide();
    }
    $('.product--price').text(Shopify.formatMoney(finalPrice, $('body').data('money-format')));
 
 });
 
 $('.boost-wellness p').filter(function() {
    return $(this).text().trim() === '';
 }).remove();
 
 $(document).on('click', '.plus-control, .minus-control', function () {
    let $quantityInput = $('.quantity-element');
    let quantity = parseInt($quantityInput.val()) || 0;
    let price = parseFloat($('.js_product_var_change option:selected').attr('data-money_without-currency-price')) || 0;
    let savingPrice = parseFloat($('.js_product_var_change option:selected').attr('data-save-without-money')) || 0;
    if ($(this).hasClass('plus-control')) {
        quantity++;
    } else if ($(this).hasClass('minus-control') && quantity > 1) {
        quantity--;
    }

    $quantityInput.val(quantity);
    
    let total = quantity * price;
    let totalSaving = quantity * savingPrice;
    $('.product--price').text(Shopify.formatMoney(total, $('body').data('money-format')));
    let formattedSaving = Shopify.formatMoney(totalSaving, $('body').data('money-format'));  
    $('.save--price').html(`(${formattedSaving} Savings)`);


});

$(document).on('click', '.js_write_review_btn', function (e) {
   e.preventDefault();
   $('#yotpo-main-widget-btn').trigger('click');
});

$(document).on('click', '.js_review_star_rating .yotpo-reviews-star-ratings-widget', function (e) {
   e.preventDefault();
    setTimeout(function() {
       let reviewsSummaryLen =  $('#yotpo-summary').length;
       if (reviewsSummaryLen > 0) {
           // Do something if reviews exist
           $('#yotpo-summary').trigger('click');
       }
       if (reviewsSummaryLen < 1) {
          $('.js_review_tab').trigger('click');
           $('html, body').animate({
               scrollTop: $('.eq-pdp-testimonial').offset().top
           }, 500);
       }
      
   }, 100); 
   console.log('click')
  });

$(document).ready(function () {
   let productForSlideFancy = $('[data-fancybox="productForSlider"]');
   if(productForSlideFancy){
     productForSlideFancy.fancybox({
       wheel: false, // Disable the mouse scroll wheel for changing slides
       loop: false,            // Enable looping of the gallery
       autoplay: false,        // Enable autoplay for slideshows
       arrows: true,          // Enable navigation arrows
       infobar: true,         // Show the information bar
       toolbar: true,         // Show the toolbar
       smallBtn: false,        // Show the small close button
       keyboard: true,        // Enable keyboard navigation
       touch: true,           // Enable touch swipe gestures
       animationEffect: 'fade',  // Use fade effect for opening/closing
       transitionEffect: 'slide', // Use slide transition between items
       thumbs: false,          // Enable thumbnails navigation
       idleTime: 3000,        // Set idle time before gallery auto-closes
       closeClick: true,       // Close gallery when clicking outside
       buttons: [
         'close',
       ]
     });    
   }
   $('.pdp-radio--option').trigger('change');
 });